// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"standard-image__wrapper___1LlVA","image":"standard-image__image___1X_JN"};


//////////////////
// WEBPACK FOOTER
// ./app/components/shared/StandardImage/standard-image.scss
// module id = 943
// module chunks = 0